import { Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';

const ALL_VALUE = 'all';

export const SERVICE_OPTIONS: { label: string; value: string }[] = [
  { label: '전체', value: ALL_VALUE },
  { label: '직연동', value: 'direct' },
  { label: '포인트홈', value: 'pointhome' },
];

interface NaverServiceFilterProps {
  selected?: string;
  onSelect: (service?: string) => void;
}

export default function NaverServiceFilter({ selected, onSelect }: NaverServiceFilterProps) {
  const handleChange = (e: SelectChangeEvent) => {
    const value = e.target.value;
    onSelect(value === ALL_VALUE ? undefined : value);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <Typography fontWeight={500} fontSize="0.85rem" color="#64748b" sx={{ whiteSpace: 'nowrap' }}>
        서비스
      </Typography>
      <Select
        value={selected ?? ALL_VALUE}
        onChange={handleChange}
        size="small"
        sx={{
          minWidth: 160,
          bgcolor: '#f8fafc',
          borderRadius: 2.5,
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0044D2' },
        }}
      >
        {SERVICE_OPTIONS.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
